import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography, Button as MUIButton } from '@mui/material'
import { ChevronLeftMinor, QuestionMarkMajor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { Settings } from 'src/components/settings/Settings'
import { RemoteConfigBanner } from 'src/components/shared/RemoteConfigBanner'
import { RemoteConfigKey } from 'src/constants/remoteConfig'

interface Props {
  hideSettings?: boolean
  onBack?: () => void
  handleGetHelp: () => void
  handleBack: () => void
  onBannerHeightChange: (height: number) => void
}

const ClientMobileStepsHeaderComponent = ({
  hideSettings,
  onBack,
  handleGetHelp,
  handleBack,
  onBannerHeightChange,
}: Props) => {
  return (
    <div css={tw`[box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.07)] fixed w-full z-50 top-0`}>
      <div css={tw`bg-shades-0 h-16 p-4 flex items-center justify-between`}>
        <MUIButton
          variant="contained"
          color="secondary"
          onClick={onBack || handleBack}
          css={tw`bg-shades-100 hover:bg-shades-200 h-[42px]`}
          data-testid="header-nav-back-btn"
        >
          <div css={tw`items-center flex flex-row`}>
            <ChevronLeftMinor width={20} />
            <Typography css={tw`text-shades-1000 [font-weight: 600]`}>Back</Typography>
          </div>
        </MUIButton>
        {!hideSettings && (
          <div css={tw`flex-row flex gap-2`}>
            <Button
              className={tw`w-[120px] px-3`}
              rightIcon={<QuestionMarkMajor css={tw`fill-primary-500`} width={20} height={20} />}
              onClick={handleGetHelp}
              color="light"
              size="medium"
              data-testid="header-help-open-btn"
            >
              Get Help
            </Button>
            <Settings flow="client" variant="light" />
          </div>
        )}
      </div>
      <RemoteConfigBanner
        configKey={RemoteConfigKey.ClientBanner}
        className={tw`rounded-none`}
        onHeightChange={onBannerHeightChange}
      />
    </div>
  )
}

export const ClientMobileStepsHeader = memo(ClientMobileStepsHeaderComponent)
